import React from 'react';

import { MovePlannerHostProvider } from '@hopdrive/feature-move-planner';

import { useDealerPlannerHost } from './useDealerPlannerHost';

/** Mounts the Move Planner's host for the Dealer. */
export function DealerPlannerHost({ children }: { children?: React.ReactNode }) {
  const host = useDealerPlannerHost();
  return <MovePlannerHostProvider value={host}>{children}</MovePlannerHostProvider>;
}
